import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import serviceProviderPricingApi, {
  ChangeServiceProviderSettings,
  ServiceProviderSettings,
} from "./api/serviceProviderPricingApi";

export interface ServiceProviderPricingState {
  settings: ServiceProviderSettings | undefined;
  loading: boolean;
  saving: boolean;
  success: string | undefined;
  error: string | undefined;
}

const initialState: ServiceProviderPricingState = {
  settings: undefined,
  loading: false,
  saving: false,
  success: undefined,
  error: undefined,
};

export const getPricingDefaults = createAsyncThunk(
  "serviceProviderPricing/getDefaults",
  async () => {
    return serviceProviderPricingApi.getSettings();
  }
);

export const savePricingDefaults = createAsyncThunk(
  "serviceProviderPricing/saveDefaults",
  async (model: ChangeServiceProviderSettings) => {
    return serviceProviderPricingApi.saveSettings(model);
  }
);

const serviceProviderPricingSlice = createSlice({
  name: "serviceProviderPricing",
  initialState,
  reducers: {
    clearPricingSuccess: (state) => {
      state.success = undefined;
    },
    clearPricingError: (state) => {
      state.error = undefined;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPricingDefaults.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(getPricingDefaults.fulfilled, (state, { payload }) => {
        state.settings = payload;
        state.loading = false;
      })
      .addCase(getPricingDefaults.rejected, (state, { error }) => {
        state.error = error.message;
        state.loading = false;
      });

    builder
      .addCase(savePricingDefaults.pending, (state) => {
        state.saving = true;
        state.error = undefined;
        state.success = undefined;
      })
      .addCase(savePricingDefaults.fulfilled, (state) => {
        state.saving = false;
        state.success = "saved";
      })
      .addCase(savePricingDefaults.rejected, (state, { error }) => {
        state.saving = false;
        state.error = error.message;
      });
  },
});

export const { clearPricingSuccess, clearPricingError } =
  serviceProviderPricingSlice.actions;

export default serviceProviderPricingSlice.reducer;
